import React, { Component } from 'react';
import { dispatch } from 'react-redux'



class Content extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (

            <div className="sign-in-content">
                    <font face="verdana" size="3" color="#696969" ><b>E-signature allows you to access and review
                        Benefit Plans shared by your tax preparer.<br /><br />
                        This session will expire in 30 minutes. Please save the PDF locally if
                        you need morethan 30 minutes for review. If the session expires, first review
                            the saved PDF, then sign in again to submit your signature</b></font>
            </div>);
    }
}




export default Content;